var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"arena-card-timer":""}},[_vm._t("default",null,{"joinState":_vm.statusMap.joinState,"remainsToNextState":_vm.statusMap.remainsToNextState})],2)}
var staticRenderFns = []

export { render, staticRenderFns }